import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconChevronRight: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M6 4L10 8L6 12"
    />
  </svg>
);

export {
  IconChevronRight,
};
